import { getAccountByMailboxInfo } from 'owa-account-source-list-store';
import { shouldShowAccountDescription } from 'owa-account-source-list';
import type { MailboxInfo } from 'owa-client-types';
import { getAccountScopeUserSettings } from 'owa-session-store';

export const getMailboxLabelForFavorite = (mailboxInfo: MailboxInfo): string | undefined => {
    if (mailboxInfo) {
        if (mailboxInfo.type === 'ArchiveMailbox') {
            const userConfig = getAccountScopeUserSettings(mailboxInfo);
            return userConfig?.SessionSettings?.ArchiveDisplayName;
        }
        const accountSource = getAccountByMailboxInfo(mailboxInfo);
        if (accountSource) {
            if (shouldShowAccountDescription(accountSource) && accountSource.accountDescription) {
                return accountSource.accountDescription;
            }
            return accountSource.displayName;
        }
    }

    return undefined;
};
